module.exports = __webpack_public_path__ + "icon-facebook-40904bb0fc8865e1756413e5d3c26696.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/svg/icon-facebook.svg
// module id = 1935
// module chunks = 2 6